import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const axiosAdmin = axios.create({
  baseURL: apiUrl,
});

axiosAdmin.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosAdmin.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem("adminToken");
      window.location.href = "/admin";
    }
    return Promise.reject(error);
  }
);

export default axiosAdmin;